export default Object.freeze({
  list: [],
  info: {},
  sites: [],
  visitors: [],
});
